export enum EnvironmentType {
  "development" = "development",
  "homolog" = "homolog",
  "production" = "production",
  "hext" = "hext",
}
